import React, { useEffect } from 'react'
import twemoji from 'twemoji'
import styles from './index.module.less'
import { EMOJI } from '@hlj/hlj-utils'

const EmojiWrap = props => {
  const insertEmoji = alt => {
    props.insertEmoji && props.insertEmoji(alt)
  }

  useEffect(() => {
    document.querySelectorAll('.emoji').forEach(item => {
      item.addEventListener('click', () => {
        insertEmoji(item.getAttribute('alt'))
      })
    })
    // eslint-disable-next-line
  }, [])

  const insertImg = () => {
    let str = ''
    Object.keys(EMOJI).forEach(item => {
      str =
        str +
        '<img src="https://qnc.hunliji.com/emoji/' +
        EMOJI[item] +
        '@2x.png" class="emoji" alt =' +
        '[' +
        item +
        ']' +
        '>'
    })
    return str
  }

  const str = insertImg()
  const mojiList = twemoji.parse(str)
  return (
    <div
      className={styles.emojiWrap}
      dangerouslySetInnerHTML={{ __html: mojiList }}
    />
  )
}

export default EmojiWrap
